import React from 'react';
import Modal from 'react-modal';
import Login from './Login';
import SignUp from './SignUp';

export default class AuthenticationModal extends React.Component {
  state = {
    email: '',
    registered: true
  }

  componentWillMount() {
    const ZXCVBN_SRC = 'zxcvbn.js';

    const async_load = function() {
      var first, s;
      s = document.createElement('script');
      s.src = ZXCVBN_SRC;
      s.type = 'text/javascript';
      s.async = true;
      first = document.getElementsByTagName('script')[0];
      return first.parentNode.insertBefore(s, first);
    };

    if (window.attachEvent != null) {
      window.attachEvent('onload', async_load);
    } else {
      window.addEventListener('load', async_load, false);
    }
  }

  _updateEmail = email => {
    this.setState({ email: email });
  }

  // this is needed onMouseDown to prevent the input validations from firing onBlur
  _closeModal = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props._auth.toggleAuthenticationModal();
  }

  registeredUser = bool => {
    this.setState({ registered: bool });
  }

  render() {
    const { auth } = this.props;

    return <Modal
      isOpen={auth.get('modal')}
      closeTimeoutMS={150}
      className="modal-dialog"
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(12, 10, 10, 0.75)'
        }
      }}
      contentLabel="Sign In">
        <div className="modal-content">
          <div>
            <button type="button" className="close" onMouseDown={this._closeModal}>
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">Close</span>
            </button>
          </div>
          <div className="modal-body signin">
            {this.state.registered &&
              <Login
                {...this.props}
                registeredUser={this.registeredUser}
                updateEmail={this._updateEmail}
                email={this.state.email} />}

            {!this.state.registered &&
              <SignUp
                {...this.props}
                registeredUser={this.registeredUser}
                updateEmail={this._updateEmail}
                email={this.state.email} />}
          </div>
        </div>
    </Modal>
  }
}



// WEBPACK FOOTER //
// ./src/components/User/AuthenticationModal.js